import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link, useNavigate } from "react-router-dom";
import SEO from "../../common-components/SEO";

export const Postgraduate = () => {
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      {/* Add SEO Tags */}
      <SEO
        fullTitle={"Master of Architecture (M.Arch) — Environmental Architecture | McGAN'S Ooty School of Architecture"}
        description={"M.Arch (Environmental Architecture) at McGAN'S Ooty."}
        keywords={`M.Arch, Environmental Architecture, sustainable architecture, COA approved, McGAN'S Ooty`}
        image={"https://mcgansarch.com/assets/images/academics/4.webp"}
        url={"https://mcgansarch.com/postgraduate"}
      />

      <div>

         
        <h1 style={{ display: "none" }}>
          M.Arch in Environmental Architecture -
          McGAN's Ooty
        </h1>
      </div>
      {/* Start Page Banner */}
      <div className="page-banner-area bg-1">
        <div className="container">
          <div className="page-banner-content">
            <h3 className="BannerHeader">Post Graduate</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="navspace">Post Graduate</li>
            </ul>
          </div>
        </div>
      </div>
      {/* End Page Banner */}

      {/* <!--Start Academic Details Area--> */}
      <div className="academics-details-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="academics-details">
                <div className="details">
                  <h2>Master of Architecture (Environmental Architecture)</h2>
                  <p>
                    A Top Architecture College in India.Companion to undergraduate in the graduate program is
                    Environmental Architecture, which greatly contributed to the
                    department´s strength. The influence of these programs has
                    created a philosophy that is unique to McGAN’S. This program
                    is approved by Council of Architecture (COA) and the
                    institute is Affiliated to Anna University, Chennai with an
                    intake of 20 Seats.
                  </p>
                  <p>
                    We are the only college offering Environmental Architecture
                    in South India. The syllabus is being made to inspire
                    environmental architects, who are fascinated with or
                    practicing green and low impact environmental impact
                    buildings. The peculiar setting selected by McGAN’S itself
                    inspires the masters to come and learn here. The program is
                    being conceived by the practice architects and passed out
                    graduate students here.
                  </p>
                  <div className="details-images">
                    <div className="row">
                      <div className="col-lg-4 col-md-4">
                        <img
                          src="assets/images/academics/4.webp"
                          title="AC4"
                          alt="AC4"
                          width={416}
                          height={360}
                        />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <img
                          src="assets/images/academics/5.webp"
                          title="AC5"
                          alt="AC5"
                          width={416}
                          height={360}
                        />
                      </div>
                      <div className="col-lg-4 col-md-4">
                        <img
                          src="assets/images/academics/6.webp"
                          title="AC6"
                          alt="AC6"
                          width={416}
                          height={360}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                 <div class="regiStartion-and-fee">
                  <h3>Eligibility</h3>
                  
                  <div class="list">
                    <ul>
                        <li>
                        <i className="ri-checkbox-circle-line iconStyle"></i>
                    Degree:
Candidates must hold a Bachelor’s Degree in Architecture (B.Arch) from a recognized university or institution.

                  </li>
                      <li>
                        <i className="ri-checkbox-circle-line iconStyle"></i>
                        Academic Qualification:
A minimum of 50% aggregate marks in the qualifying degree is required.
(For SC/ST candidates, a minimum of 45% is acceptable as per regulations.)

                      </li>
                      <li>
                        <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
                        Entrance Examination:
Applicants must possess a valid score in the Post Graduate Entrance Test in Architecture (PGETA) conducted by the Council of Architecture (CoA).
                      </li>
                     
                    </ul>
                  </div>
                </div>
<div className="row regiStartion-and-fee mt-4">
  <div className="col-lg-12">
    <h3>M.Arch(Environmental Architecture) Regulations & Downloads</h3>
    <div className="list">
      <ul>
        <li>
          <i className="ri-file-pdf-line iconStyle"></i>{" "}
          <a
            href="assets/images/doc/M.Arch-EV-Regulations-2025.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="pdf-link"
          >
            M.Arch Regulations(Environmental Architecture) – 2025
          </a>
        </li>
        
      </ul>
    </div>
  </div>
</div>
                <div className="row regiStartion-and-fee">
                  <div className="col-6">
                    <h3>How to Apply :</h3>
                    <div className="list">
                      <ul>
                        <li>
                          <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
                          Review the application requirements carefully.
                        </li>
                        <li>
                          <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
                          Gather and prepare all required documents.
                        </li>
                        <li>
                          <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
                          Fill out the application form accurately.
                        </li>
                        <li>
                          <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
                          Submit your application on time.
                        </li>
                        <li>
                          <i className="ri-checkbox-circle-line iconStyle"></i>{" "}
                          Follow up if needed to confirm submission.
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-6">
                    <h3>Apply Application & Fees</h3>
                    <div className="list">
                      <ul>
                        <button
                          type="button"
                          className="default-btn btn"
                          onClick={() => navigate(`/march-application`)}
                        >
                          Apply Now <i className="flaticon-next"></i>
                        </button>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!--End Academic Details Area--> */}
    </>
  );
};
